import { Link } from "react-router-dom";
import { allCategories } from "@/data/videos";

export default function Footer() {
  return (
    <footer className="border-t border-primary-900/40 bg-primary-950 text-background-100">
      <div className="container-page py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-sm font-extrabold text-background-50">
                91
              </span>
              <span className="font-heading text-lg font-extrabold text-background-50">
                免费视频网站91
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              免费视频网站91 致力于为用户提供丰富的免费视频内容，涵盖电影、电视剧、综艺、动画、纪录片、短视频等多种类别，让您轻松在线观看各类高清视频，体验流畅观影乐趣。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-400">
              本站所有视频标题、封面与简介均为演示示例数据，非真实视频资源。播放为前端演示，真实播放需服务端支持接入。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              视频分类
            </h4>
            <ul className="mt-4 space-y-2">
              {allCategories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              快捷导航
            </h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link
                  to="/"
                  className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                >
                  搜索视频
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                >
                  免责声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900/50 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 免费视频网站91 · 本站为演示站点，内容仅供浏览体验</p>
          <p>免费高清在线视频资源平台 · 用心呈现每一帧</p>
        </div>
      </div>
    </footer>
  );
}